import { CheckPermission, Permission } from '@/features/auth'
import { Requests as RequestsList } from '@/features/order'

function Requests() {
  return (
    <CheckPermission permissions={[Permission.ORDER_READ]} redirect="/goodies">
      <RequestsList />
    </CheckPermission>
  )
}

export default Requests
